module.exports = __webpack_public_path__ + "img/9849209.png";